import { createAction, createSlice } from "@reduxjs/toolkit";

const updateReviewCourseSlice = createSlice({
  name: "updateReviewCourse",
  initialState: { hasError: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      state.hasError = false;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      state.hasError = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      state.hasError = true;
      /* TODO: reducer for failure*/
    },
    resetError(state) {
      state.hasError = null;
    },
  },
});

const { name, actions, reducer } = updateReviewCourseSlice;
const updateReviewCourseAction = createAction(name);

export {
  updateReviewCourseAction,
  actions as updateReviewCourseActions,
  reducer as updateReviewCourseReducer,
};
